import React from 'react';
import styles from './WorkspaceToolbar.module.css';

// One owner for wrapping, control spacing and alignment; no layout rules on
// generic buttons, dialogs or all children of the application.
export default function WorkspaceToolbar({ children, label, className = '' }) {
  return <div className={`${styles.toolbar} ${className}`} role={label ? 'group' : undefined} aria-label={label}>{children}</div>;
}
